var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-supplier" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品名称",
            visible: _vm.dialogFormVisible,
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "价格形式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.priceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "priceType", $$v)
                        },
                        expression: "form.priceType",
                      },
                    },
                    _vm._l(_vm.priceEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "值：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.newPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newPrice", _vm._n($$v))
                      },
                      expression: "form.newPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效时间：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.effectiveDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "effectiveDate", $$v)
                        },
                        expression: "form.effectiveDate",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("立即生效"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { attrs: { label: 2 } },
                        [
                          _c("span", [_vm._v("指定时间")]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            attrs: {
                              disabled: _vm.form.effectiveDate != 2,
                              type: "datetime",
                              placeholder: "选择日期时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.form.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "time", $$v)
                              },
                              expression: "form.time",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }